import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    userId: string;
};

export const schemaUserResolver_GetAdvisersToBeRepresented = z.array(
    UsersTableDefinitionZod.pick({
        deactivated: true,
        firstName: true,
        id: true,
        lastName: true,
    }),
);

export type SchemaUserResolver_GetAdvisersToBeRepresented = z.infer<
    typeof schemaUserResolver_GetAdvisersToBeRepresented
>;

export type UserResolver_GetAdvisersToBeRepresented = Resolver<
    Arguments,
    SchemaUserResolver_GetAdvisersToBeRepresented
>;
